import { render } from "./CurriculumHistory.vue?vue&type=template&id=fb75e0ca&scoped=true"
import script from "./CurriculumHistory.vue?vue&type=script&lang=js"
export * from "./CurriculumHistory.vue?vue&type=script&lang=js"

import "./CurriculumHistory.vue?vue&type=style&index=0&id=fb75e0ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb75e0ca"]])

export default __exports__